var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('app-page-header'),(_vm.role == 'admin')?_c('root-parking-occupancy'):_c('user-parking-occupancy')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }